import stbAPIGateway from '../../../../services/stbAPIGateway';

export const generateClientSecretKey = async ({ rootGetters }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);
  const secretKey = await stbApi.getNewClientSecretKey();
  return secretKey;
};
